// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-pages-usageReportingContainer-components-skeletonLoader-module__skeleton--vfThk {
  padding: 10px 0;
}

.src-js-pages-usageReportingContainer-components-skeletonLoader-module__scorecardsRow--VCsnw {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.src-js-pages-usageReportingContainer-components-skeletonLoader-module__scorecardBlock--J5n2L {
  flex: 1;
  height: 70px;
  border-radius: 6px;
  background: linear-gradient(90deg, rgba(255,255,255,0.04) 25%, rgba(255,255,255,0.08) 50%, rgba(255,255,255,0.04) 75%);
  background-size: 200% 100%;
  animation: src-js-pages-usageReportingContainer-components-skeletonLoader-module__shimmer--X66CH 1.5s infinite;
}

.src-js-pages-usageReportingContainer-components-skeletonLoader-module__chartBlock--smuIB {
  height: 220px;
  border-radius: 6px;
  margin-bottom: 20px;
  background: linear-gradient(90deg, rgba(255,255,255,0.04) 25%, rgba(255,255,255,0.08) 50%, rgba(255,255,255,0.04) 75%);
  background-size: 200% 100%;
  animation: src-js-pages-usageReportingContainer-components-skeletonLoader-module__shimmer--X66CH 1.5s infinite;
}

.src-js-pages-usageReportingContainer-components-skeletonLoader-module__tablesRow--g8z_J {
  display: flex;
  gap: 15px;
}

.src-js-pages-usageReportingContainer-components-skeletonLoader-module__tableBlock--8uziv {
  flex: 1;
  height: 180px;
  border-radius: 6px;
  background: linear-gradient(90deg, rgba(255,255,255,0.04) 25%, rgba(255,255,255,0.08) 50%, rgba(255,255,255,0.04) 75%);
  background-size: 200% 100%;
  animation: src-js-pages-usageReportingContainer-components-skeletonLoader-module__shimmer--X66CH 1.5s infinite;
}

@keyframes src-js-pages-usageReportingContainer-components-skeletonLoader-module__shimmer--X66CH {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/js/pages/usageReportingContainer/components/skeletonLoader.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,sHAAsH;EACtH,0BAA0B;EAC1B,8GAAgC;AAClC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,sHAAsH;EACtH,0BAA0B;EAC1B,8GAAgC;AAClC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,OAAO;EACP,aAAa;EACb,kBAAkB;EAClB,sHAAsH;EACtH,0BAA0B;EAC1B,8GAAgC;AAClC;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":[".skeleton {\n  padding: 10px 0;\n}\n\n.scorecardsRow {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.scorecardBlock {\n  flex: 1;\n  height: 70px;\n  border-radius: 6px;\n  background: linear-gradient(90deg, rgba(255,255,255,0.04) 25%, rgba(255,255,255,0.08) 50%, rgba(255,255,255,0.04) 75%);\n  background-size: 200% 100%;\n  animation: shimmer 1.5s infinite;\n}\n\n.chartBlock {\n  height: 220px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  background: linear-gradient(90deg, rgba(255,255,255,0.04) 25%, rgba(255,255,255,0.08) 50%, rgba(255,255,255,0.04) 75%);\n  background-size: 200% 100%;\n  animation: shimmer 1.5s infinite;\n}\n\n.tablesRow {\n  display: flex;\n  gap: 15px;\n}\n\n.tableBlock {\n  flex: 1;\n  height: 180px;\n  border-radius: 6px;\n  background: linear-gradient(90deg, rgba(255,255,255,0.04) 25%, rgba(255,255,255,0.08) 50%, rgba(255,255,255,0.04) 75%);\n  background-size: 200% 100%;\n  animation: shimmer 1.5s infinite;\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skeleton": `src-js-pages-usageReportingContainer-components-skeletonLoader-module__skeleton--vfThk`,
	"scorecardsRow": `src-js-pages-usageReportingContainer-components-skeletonLoader-module__scorecardsRow--VCsnw`,
	"scorecardBlock": `src-js-pages-usageReportingContainer-components-skeletonLoader-module__scorecardBlock--J5n2L`,
	"shimmer": `src-js-pages-usageReportingContainer-components-skeletonLoader-module__shimmer--X66CH`,
	"chartBlock": `src-js-pages-usageReportingContainer-components-skeletonLoader-module__chartBlock--smuIB`,
	"tablesRow": `src-js-pages-usageReportingContainer-components-skeletonLoader-module__tablesRow--g8z_J`,
	"tableBlock": `src-js-pages-usageReportingContainer-components-skeletonLoader-module__tableBlock--8uziv`
};
export default ___CSS_LOADER_EXPORT___;
